<template>
  <footer class="border-t border-neutral-200 dark:border-neutral-800 bg-white dark:bg-neutral-900 py-3 mt-auto">
    <div class="px-6 flex items-center justify-between">
      <p class="text-xs text-neutral-500 dark:text-neutral-400">
        &copy; {{ currentYear }} Neutral Fuels Holdings Ltd.
      </p>
      <p class="text-xs text-neutral-500 dark:text-neutral-400">
        <span class="font-medium text-neutral-500 dark:text-neutral-400">OMS</span>
        by
        <a href="https://neutralfuels.com" target="_blank" rel="noopener noreferrer" class="text-primary-600 dark:text-primary-400 hover:underline transition-colors">Neutral Fuels</a>
      </p>
    </div>
  </footer>
</template>

<script>
import { computed } from 'vue'

export default {
  setup() {
    const currentYear = computed(() => new Date().getFullYear())
    return { currentYear }
  }
}
</script>
